export const app = {
  name: "Welcome to Retirement Edge",
  environment: "development",
};

export const msgs = {
  success: "Operation successful.",
  error: "Operation failed.",
  noRows: "No records to display.",
  authError: "Your session has expired. Please log in again.",
  fieldError: "This field is required.",
  annuityAllocationAuthError:
    "An error occurred while updating allocations or Session Expired",
  normalTextError:
    "Only letters, numbers, spaces, apostrophes, colons, periods, and hyphens are allowed",
};

const apiBaseUrls = {
  localhost: "https://localhost:44386/api/1/",
  "dev-ui.retirement-edge.com":
    "https://app-api-recore-dev-cus.azurewebsites.net/api/1/",
  "stage-ui.retirement-edge.com":
    "https://app-api-recore-staging-centralus.azurewebsites.net/api/1/",
  "ui.retirement-edge.com":
    "https://app-api-recore-centralus.azurewebsites.net/api/1/",
};

export const getApiBaseUrl = () => {
  const hostname = window.location.hostname;

  return apiBaseUrls[hostname] || apiBaseUrls["dev-ui.retirement-edge.com"];
};

export const baseUrl = getApiBaseUrl().replace(/1\/$/, "");
export const conf = {
  serverURL: getApiBaseUrl(),
  idleTimeout: 10,
};

export const domainUrl = {
  local: "localhost:3001",
  dev: "dev-annuitant-ui.retirement-edge.com",
  stage: "stage-annuitant-ui.retirement-edge.com",
  production: "annuitant-ui.retirement-edge.com",
};

export const pagination = {
  length: 20,
  list: [20, 30, 40, 50],
};

export const statusOptions = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];

export const progressStatusOptions = [
  { label: "In Progress", value: "In Progress" },
  { label: "Completed", value: "Completed" },
  { label: "Failed", value: "Failed" },
  { label: "Error", value: "Error" },
];

export const dateRangeOptions = [
  { label: "All Entries", value: "AllEntries" },
  { label: "Current Month", value: "CurrentMonth" },
  { label: "Last Month", value: "LastMonth" },
  { label: "Current Quarter", value: "CurrentQuarter" },
  { label: "Last Quarter", value: "LastQuarter" },
  { label: "Custom Range", value: "CustomRange" },
  { label: "Today", value: "Today" },
];

export const RETIREMENT_AGE = 67;
export const GROWTH_RATE = 0.02;
export const INACTIVE_TIMEOUT = conf.idleTimeout * 60 * 1000;
